export default __webpack_public_path__ + "static/media/logo_ig.93a0543e.svg";